import {useTranslation} from "react-i18next";
import IconCornerRightUp from "../../../assets/corner-right-up.svg?react";
import {FollowUpSuggestion} from "../../../types";
import classes from "./FollowUpSuggestionChips.module.css";

interface Props {
    suggestions: FollowUpSuggestion[];
    onSelect: (question: string) => void;
}

export const FollowUpSuggestionChips: React.FC<Props> = ({
    suggestions,
    onSelect,
}) => {
    const {t} = useTranslation();

    if (suggestions.length === 0) {
        return null;
    }

    return (
        <div
            className={classes.root}
            role="group"
            aria-label={t("chat.followUpSuggestions.groupLabel", {
                defaultValue: "Suggested follow-up questions",
            })}
            data-name="followup-suggestions"
        >
            {suggestions.map((suggestion) => (
                <button
                    key={suggestion.question}
                    type="button"
                    className={classes.chip}
                    data-kind={suggestion.kind}
                    onClick={() => onSelect(suggestion.question)}
                >
                    <span className={classes.question}>
                        {suggestion.question}
                    </span>
                    <span className={classes.chevron} aria-hidden="true">
                        <IconCornerRightUp />
                    </span>
                </button>
            ))}
        </div>
    );
};
